import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import { useLocation, useSearchParams } from "react-router-dom";
import DeletionStatusMain from "./DeletionStatusMain";
import { trackEvent } from "../../../services/GoogleAnalytics";
import { shouldUseLegalAppShell, syncAppLegalWebViewState } from "../../../config/appWebViewLegal";

export default function DeletionStatusPage() {
    const location = useLocation();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        syncAppLegalWebViewState(location.pathname, searchParams, location.hash);
    }, [location.pathname, searchParams, location.hash]);

    useEffect(() => {
        trackEvent("entered", { name: "DeletionStatusPage", path: location.pathname });
    }, [location.pathname]);

    const legalAppShell = shouldUseLegalAppShell(
        location.pathname,
        location.search,
        location.hash,
    );

    return (
        <Box
            sx={{
                width: "100%",
                minHeight: "100vh",
                ...(legalAppShell ? { pt: { xs: 1, sm: 1.5 } } : {}),
            }}
        >
            <DeletionStatusMain />
        </Box>
    );
}
